import { ApiError } from "@/api/client";

// Map opaque server error codes to friendly, in-voice copy. Keeps the raw code
// out of the operator's face while still routing known cases to a helpful line;
// unknown errors fall back by HTTP status family. Pass the i18n `t`.
const CODE_KEYS: Record<string, string> = {
  "agent.offline": "errors.agent_offline",
  "approval.required": "errors.approval_required",
  "approval.unauthorized": "errors.approval_unauthorized",
  "authz.insufficient_role": "errors.forbidden",
  "session.gone": "errors.session_gone",
  "clipboard.unsupported": "errors.clipboard_unsupported",
  "clipboard.too_large": "errors.clipboard_too_large",
  "clipboard.invalid_image": "errors.clipboard_invalid_image",
  "clipboard.disconnected": "errors.session_gone",
  "clipboard.upload_failed": "errors.clipboard_upload_failed",
  "clipboard.timeout": "errors.clipboard_upload_failed",
};

export function describeError(err: unknown, t: (key: string) => string): string {
  if (err instanceof ApiError) {
    const mapped = CODE_KEYS[err.code];
    if (mapped) return t(mapped);
    if (err.code.startsWith("validation.")) return t("errors.validation");
    if (err.code.startsWith("conflict.")) return t("errors.conflict");
    if (err.status === 403) return t("errors.forbidden");
    if (err.status === 404) return t("errors.not_found");
    if (err.status === 0 || err.status >= 500) return t("errors.server");
    return t("errors.generic");
  }
  if (err instanceof Error && err.message) return err.message;
  return t("errors.generic");
}
